import { Link } from "react-router-dom"
import "./AboutContent.css"
import img1 from "../assets/img1.jpg"
import img2 from "../assets/img2.avif"
import React from 'react'



const AboutContent = () => {
  return (
    <div className="about">
        <div className="left">
            <h1>Why choose solar energy?</h1>
            <p>Savings on your energy bill from the first month, Independence from rate increases, Added value to your property, Clean and renewable energy, Access to tax benefits (Law 1715 of 2014)</p>
            <Link to="/contact">
                <button className="btn">
                    Contact
                </button>
            </Link>
        </div>
        
        <div className="right">
            <div className="img-container">
                <div className="img-stack top">
                    <img src={img2} className="img" alt="img1"/>
                </div>
                <div className="img-stack bottom">
                    <img src={img1} className="img" alt="img2"/>
                </div>

            </div>

        </div>

        
    </div>
  )
}

export default AboutContent